import bootstrapper from '../bootstrapper';
import {
  displayFlashErrorMessage, removeFlashErrorMessage, disableItems, enableItems,
} from './checkoutHelpers';

class PaymentSubmission {
  constructor (paymentMethod, paymentInstallmentId, paymentId) {
    this.paymentMethod = paymentMethod;
    this.paymentInstallmentId = paymentInstallmentId;
    this.paymentId = paymentId;
  }

  requestParams = () => {
    const currentUrlParams = new URLSearchParams(window.location.search);
    const urlParamsProcessed = Object.fromEntries(currentUrlParams);
    if (this.paymentMethod && 'selected_payment_method' in urlParamsProcessed) delete urlParamsProcessed.selected_payment_method;
    const params = {
      'shop_payment_installment[selected_payment_method]': this.paymentMethod,
      'shop_payment_installment[switch_payment_method]': true,
      ...urlParamsProcessed,
    };

    return params;
  };

  requestUrl = () => {
    const serverUrl = `${window.location.origin}/${bootstrapper.locale}/payment_installments/${this.paymentInstallmentId}/payments/${this.paymentId}`;
    const url = `${serverUrl}?${new URLSearchParams(this.requestParams()).toString()}`;
    const cleanUrl = window.location.href.split('?')[0];
    window.history.replaceState(null, null, cleanUrl);

    return url;
  };

  paymentMethodUpdateRequest = async () => {
    const CsrfToken = document.querySelector('input[name="authenticity_token"]')?.value;
    const options = {
      method: 'PATCH',
      headers: {
        Accept: 'text/vnd.turbo-stream.html',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': CsrfToken,
      },
    };

    return fetch(this.requestUrl(), options);
  };

  processedResponse = async () => {
    const response = await this.paymentMethodUpdateRequest();
    const responseData = await response.text();

    if (response.ok) return responseData;

    throw new Error(JSON.parse(responseData).error);
  };

  reload = () => {
    disableItems();
    removeFlashErrorMessage();
    this.processedResponse()
      .then((response) => {
        // eslint-disable-next-line no-undef
        Turbo.renderStreamMessage(response);
        enableItems();
      })
      .catch((error) => {
        displayFlashErrorMessage(error.message);
      });
  };
}


export default PaymentSubmission;
